/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PayerMaintenanceResponse } from '../models';
// @ts-ignore
import type { PayerResponse } from '../models';
// @ts-ignore
import type { PayersResponse } from '../models';
// @ts-ignore
import type { TransactionType } from '../models';
/**
 * EZAPIPayersApi - axios parameter creator
 * @export
 */
export const EZAPIPayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} payerId 
         * @param {Array<TransactionType>} [transactionTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayerById: async (payerId: string, transactionTypes?: Array<TransactionType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getEZAPIPayerById', 'payerId', payerId)
            const localVarPath = `/api/v1/ezapi/payer/{payerId}`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (transactionTypes) {
                localVarQueryParameter['transactionTypes'] = transactionTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayerMaintenance: async (payerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getEZAPIPayerMaintenance', 'payerId', payerId)
            const localVarPath = `/api/v1/ezapi/payer/{payerId}/maintenance`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ezapi/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EZAPIPayersApi - functional programming interface
 * @export
 */
export const EZAPIPayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EZAPIPayersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} payerId 
         * @param {Array<TransactionType>} [transactionTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEZAPIPayerById(payerId: string, transactionTypes?: Array<TransactionType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEZAPIPayerById(payerId, transactionTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EZAPIPayersApi.getEZAPIPayerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEZAPIPayerMaintenance(payerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayerMaintenanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEZAPIPayerMaintenance(payerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EZAPIPayersApi.getEZAPIPayerMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEZAPIPayers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEZAPIPayers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EZAPIPayersApi.getEZAPIPayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EZAPIPayersApi - factory interface
 * @export
 */
export const EZAPIPayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EZAPIPayersApiFp(configuration)
    return {
        /**
         * 
         * @param {EZAPIPayersApiGetEZAPIPayerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayerById(requestParameters: EZAPIPayersApiGetEZAPIPayerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayerResponse> {
            return localVarFp.getEZAPIPayerById(requestParameters.payerId, requestParameters.transactionTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EZAPIPayersApiGetEZAPIPayerMaintenanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayerMaintenance(requestParameters: EZAPIPayersApiGetEZAPIPayerMaintenanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerMaintenanceResponse>> {
            return localVarFp.getEZAPIPayerMaintenance(requestParameters.payerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEZAPIPayers(options?: RawAxiosRequestConfig): AxiosPromise<Array<PayersResponse>> {
            return localVarFp.getEZAPIPayers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EZAPIPayersApi - interface
 * @export
 * @interface EZAPIPayersApi
 */
export interface EZAPIPayersApiInterface {
    /**
     * 
     * @param {EZAPIPayersApiGetEZAPIPayerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApiInterface
     */
    getEZAPIPayerById(requestParameters: EZAPIPayersApiGetEZAPIPayerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayerResponse>;

    /**
     * 
     * @param {EZAPIPayersApiGetEZAPIPayerMaintenanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApiInterface
     */
    getEZAPIPayerMaintenance(requestParameters: EZAPIPayersApiGetEZAPIPayerMaintenanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerMaintenanceResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApiInterface
     */
    getEZAPIPayers(options?: RawAxiosRequestConfig): AxiosPromise<Array<PayersResponse>>;

}

/**
 * Request parameters for getEZAPIPayerById operation in EZAPIPayersApi.
 * @export
 * @interface EZAPIPayersApiGetEZAPIPayerByIdRequest
 */
export interface EZAPIPayersApiGetEZAPIPayerByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EZAPIPayersApiGetEZAPIPayerById
     */
    readonly payerId: string

    /**
     * 
     * @type {Array<TransactionType>}
     * @memberof EZAPIPayersApiGetEZAPIPayerById
     */
    readonly transactionTypes?: Array<TransactionType>
}

/**
 * Request parameters for getEZAPIPayerMaintenance operation in EZAPIPayersApi.
 * @export
 * @interface EZAPIPayersApiGetEZAPIPayerMaintenanceRequest
 */
export interface EZAPIPayersApiGetEZAPIPayerMaintenanceRequest {
    /**
     * 
     * @type {string}
     * @memberof EZAPIPayersApiGetEZAPIPayerMaintenance
     */
    readonly payerId: string
}

/**
 * EZAPIPayersApi - object-oriented interface
 * @export
 * @class EZAPIPayersApi
 * @extends {BaseAPI}
 */
export class EZAPIPayersApi extends BaseAPI implements EZAPIPayersApiInterface {
    /**
     * 
     * @param {EZAPIPayersApiGetEZAPIPayerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApi
     */
    public getEZAPIPayerById(requestParameters: EZAPIPayersApiGetEZAPIPayerByIdRequest, options?: RawAxiosRequestConfig) {
        return EZAPIPayersApiFp(this.configuration).getEZAPIPayerById(requestParameters.payerId, requestParameters.transactionTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EZAPIPayersApiGetEZAPIPayerMaintenanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApi
     */
    public getEZAPIPayerMaintenance(requestParameters: EZAPIPayersApiGetEZAPIPayerMaintenanceRequest, options?: RawAxiosRequestConfig) {
        return EZAPIPayersApiFp(this.configuration).getEZAPIPayerMaintenance(requestParameters.payerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EZAPIPayersApi
     */
    public getEZAPIPayers(options?: RawAxiosRequestConfig) {
        return EZAPIPayersApiFp(this.configuration).getEZAPIPayers(options).then((request) => request(this.axios, this.basePath));
    }
}

